import React, { Component, Fragment  } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Icon, Menu } from 'semantic-ui-react';
// import {} from '../actions';

class HolidayMenu extends Component {
    state = {
        selectedSubMenu: 'holidaylist',
        activeItem: ''
        
    }


    render() {
        const { activeItem } = this.state;
        const { selectedSubMenu } = this.state;

        return (
            <Fragment>
                
                <Menu fixed='left' vertical style={{ marginTop: '5em', marginLeft: '0em' }}>
                    <Menu.Item key='holidaylist' name="holidaylist" active={selectedSubMenu === 'holidaylist'}>
                        Holiday List
                    </Menu.Item>

                    {/* <Menu.Item name='messages' active={activeItem === 'messages'} onClick={this.handleExportClick.bind(this)}>
                    <Icon name='download' />
                    Export
                </Menu.Item> */}

                </Menu>

               
            </Fragment>
        )
    }
}
// const mapStateToProps = ({ sales }) => {
//     return { sales }
// }

// const matchDispatchToProps = (dispatch) => {
//     return bindActionCreators({
//         exportSales: exportSales
//     }, dispatch);
// }

export default (HolidayMenu);